import authTypes from "./authTypes";

export const setCurrentUser = (user) => {
  return {
    type: authTypes.SET_CURRENT_USER,
    payload: user,
  };
};

export const clearCurrentUser = () => {
  return {
    type: authTypes.CLEAR_CURRENT_USER,
  };
};

export const setUserData = (userData) => {
  return {
    type: authTypes.SET_USER_DATA,
    payload: {
      userData,
    },
  };
};

export const setUserDataSets = (userDataSets) => {
  return {
    type: authTypes.SET_USER_DATASETS,
    payload: {
      userDataSets,
    },
  };
};

export const setUserPresets = (userPresets) => {
  return {
    type: authTypes.SET_USER_PRESETS,
    payload: {
      userPresets,
    },
  };
};

export default authTypes;
